export default {
  USER_GET_PROVIDER: 'USER_GET_PROVIDER',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGIN_FLOW_STAGE: 'USER_LOGIN_FLOW_STAGE',
  USER_LOGIN_HANDLE_CHALLENGE: 'USER_LOGIN_HANDLE_CHALLENGE',
  USER_PROVIDER: 'USER_PROVIDER',
  USER_LOGIN_ERROR: 'USER_LOGIN_ERROR',
  USER_LOGIN_ERROR_FAILED_MIGRATION: 'USER_LOGIN_ERROR_FAILED_MIGRATION',
  USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
  USER_RESET_PASSWORD_RESPONSE: 'USER_RESET_PASSWORD_RESPONSE',
  USER_RESET_PASSWORD_CANCEL: 'USER_RESET_PASSWORD_CANCEL',
  USER_CHANGE_PASSWORD: 'USER_CHANGE_PASSWORD',
  USER_CHANGE_PASSWORD_RESPONSE: 'USER_CHANGE_PASSWORD_RESPONSE',
  USER_CHANGE_PASSWORD_ERROR: 'USER_CHANGE_PASSWORD_ERROR',
  REMOVE_PROVIDER: 'REMOVE_PROVIDER',
  SET_PROVIDER: 'SET_PROVIDER',
  TOTP_SPINNING: 'TOTP_SPINNING',
  SET_USERNAME: 'SET_USERNAME',
  SET_PASSWORD: 'SET_PASSWORD',
  SET_PASSWORD_VALIDATION: 'SET_PASSWORD_VALIDATION',
  SET_PASSWORD_ERRORS: 'SET_PASSWORD_ERRORS',
  REMEMBER_ME: 'REMEMBER_ME',
  SET_DEVICE_DATA: 'SET_DEVICE_DATA',
  SAVE_DEVICE: 'SAVE_DEVICE',
  MFA_SET_SMS_NUMBER: 'MFA_SET_SMS_NUMBER',
  MFA_ENABLE_CHOICE: 'MFA_ENABLE_CHOICE'
}